import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import KeyboardInput from '@common/components/InputKeyboard';
import { useTranslation } from '@common/hooks/translation';
import { PreferencesContext } from '@common/contexts/preferences';

import './style.scss';

const SearchInput = ({
  value,
  onChange,
  classicView,
  placeholder = 'Type to search...',
  disableKeyboard,
}) => {
  const [{ lang }] = useContext(PreferencesContext);
  const t = useTranslation();

  return (
    <div className={`search-input ${classicView ? 'search-input-classic-view' : ''}`}>
      {disableKeyboard ? (
        <div className="header-input-case">
          {!!value && (
            <i className="global-icon icon-circle-close reset-btn" onClick={() => onChange?.('')} />
          )}

          <input
            value={value}
            onChange={(e) => onChange?.(e.currentTarget.value)}
            placeholder={t(placeholder)}
          />
          <span className="global-icon icon-slim-search" />
        </div>
      ) : (
        <KeyboardInput
          onChange={onChange}
          value={value}
          lang={lang}
          placeholder={t(`${placeholder}`)}
          hasResetButton
        />
      )}
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classicView: PropTypes.bool,
  placeholder: PropTypes.string,
  disableKeyboard: PropTypes.bool,
};

export default SearchInput;
